/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/PerformanceIndicatorPollGeneralResponseReportPaginationSlice'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/PerformanceIndicatorPollGeneralResponseReportPaginationSlice'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.PerformanceIndicatorPollGeneralResponseApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.PerformanceIndicatorPollGeneralResponseReportPaginationSlice);
  }
}(this, function(ApiClient, PerformanceIndicatorPollGeneralResponseReportPaginationSlice) {
  'use strict';

  /**
   * PerformanceIndicatorPollGeneralResponse service.
   * @module api/PerformanceIndicatorPollGeneralResponseApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new PerformanceIndicatorPollGeneralResponseApi. 
   * @alias module:api/PerformanceIndicatorPollGeneralResponseApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the performanceIndicatorPollGeneralResponseLoadAllInTimePeriodGet operation.
     * @callback module:api/PerformanceIndicatorPollGeneralResponseApi~performanceIndicatorPollGeneralResponseLoadAllInTimePeriodGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PerformanceIndicatorPollGeneralResponseReportPaginationSlice} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadAllInTimePeriod
     * @param {String} _4SAPIAppID 
     * @param {Integer} pollSettingID 
     * @param {Date} startDate 
     * @param {Date} endDate 
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.onlyUnanswered  (default to false)
     * @param {module:api/PerformanceIndicatorPollGeneralResponseApi~performanceIndicatorPollGeneralResponseLoadAllInTimePeriodGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PerformanceIndicatorPollGeneralResponseReportPaginationSlice}
     */
    this.performanceIndicatorPollGeneralResponseLoadAllInTimePeriodGet = function(_4SAPIAppID, pollSettingID, startDate, endDate, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceIndicatorPollGeneralResponseLoadAllInTimePeriodGet";
      }

      // verify the required parameter 'pollSettingID' is set
      if (pollSettingID == undefined || pollSettingID == null) {
        throw "Missing the required parameter 'pollSettingID' when calling performanceIndicatorPollGeneralResponseLoadAllInTimePeriodGet";
      }

      // verify the required parameter 'startDate' is set
      if (startDate == undefined || startDate == null) {
        throw "Missing the required parameter 'startDate' when calling performanceIndicatorPollGeneralResponseLoadAllInTimePeriodGet";
      }

      // verify the required parameter 'endDate' is set
      if (endDate == undefined || endDate == null) {
        throw "Missing the required parameter 'endDate' when calling performanceIndicatorPollGeneralResponseLoadAllInTimePeriodGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'pollSettingID': pollSettingID,
        'startDate': startDate,
        'endDate': endDate,
        'onlyUnanswered': opts['onlyUnanswered']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = PerformanceIndicatorPollGeneralResponseReportPaginationSlice;

      return this.apiClient.callApi(
        '/PerformanceIndicatorPollGeneralResponse/loadAllInTimePeriod', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
